
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/react-chat/core/realtime",
      function () {
        return require("private-next-pages/x/react-chat/core/realtime.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/react-chat/core/realtime"])
      });
    }
  